export const categotiesObj = [
    {
        id: new Date().valueOf(),
        category: "Food",
        type: 'expense',
        budget: 0,
        icon: 'fastfood',
        isEnabled: true,
        currency: "MKD"
    },
    {
        id: new Date().valueOf(),
        category: "Drinks",
        type: 'expense',
        budget: 0,
        icon: 'fastfood',
        isEnabled: true,
        currency: "MKD"
    },
    {
        id: new Date().valueOf(),
        category: "Utilities",
        type: 'expense',
        budget: 0,
        icon: 'home',
        isEnabled: true,
        currency: "MKD"
    },
    {
        id: new Date().valueOf(),
        category: "Car",
        type: 'expense',
        budget: 0,
        icon: 'home',
        isEnabled: true,
        currency: "MKD"
    },
    {
        id: new Date().valueOf(),
        category: "Books",
        type: 'expense',
        budget: 0,
        icon: 'home',
        isEnabled: true,
        currency: "MKD"
    },
    {
        id: new Date().valueOf(),
        category: "Vacation",
        type: 'expense',
        budget: 0,
        icon: 'home',
        isEnabled: true,
        currency: "MKD"
    },


    {
        id: new Date().valueOf(),
        category: "Cat",
        type: 'expense',
        budget: 0,
        icon: 'home',
        isEnabled: true,
        currency: "MKD"
    },

    {
        id: new Date().valueOf(),
        category: "Salary",
        type: 'income',
        budget: 0,
        icon: 'home',
        isEnabled: true,
        currency: "MKD"
    },
    {
        id: new Date().valueOf(),
        category: "Bonus",
        type: 'income',
        budget: 0,
        icon: 'home',
        isEnabled: true,
        currency: "MKD"
    },
    {
        id: new Date().valueOf(),
        category: "Sells",
        type: 'income',
        budget: 0,
        icon: 'home',
        isEnabled: true,
        currency: "MKD"
    },

];